if (matchMedia) {
    var mq = window.matchMedia("(max-width: 1024px)");
    mq.addListener(WidthChange);
    WidthChange(mq);
  
  } 
  function WidthChange(mq) {
    $(window).scroll(function(){
      
      if (mq.matches) {
          $('.site-header').removeClass('stuck');
       }
       else {
        //alert($(this).scrollTop());
          if ($(this).scrollTop() > 1){
            $('.site-header').addClass('stuck');
          } else {
            $('.site-header').removeClass('stuck');
             
          }
       }
    });
    
  }